import authRoutes from './auth.routes';

import userMenuComponent from './components/user.menu.component';
import loadingComponent from './components/loading.component';

import userMenuController from './controllers/user.menu.controller';
import loadingController from './controllers/loading.controller';

import encryptService from './services/encrypt.service';
import permissionsService from './services/permissions.service';

let authModule = angular.module('spabooker.auth', ['spabooker.property'])
    .config(authRoutes)

    .component('userMenu', userMenuComponent)
    .component('loading', loadingComponent)

    .controller('userMenuController', userMenuController)
    .controller('loadingController', loadingController)

    .factory('encryptService', encryptService)
    .factory('permissionsService', permissionsService)

    .run(['$transitions', '$state', 'authService', 'permissionsService',
        function ($transitions, $state, authService, permissionsService) {
            $transitions.onStart({}, transition => {
                return authService.checkLoggedIn()
                    .then(() => permissionsService.retrievePermissions())
                    .then(() => {
                        if (!permissionsService.hasPermission(transition.$to())) {
                            $state.go('403');
                        }
                    })
                    .catch(() => { });
            });

            // Silence transition errors (and any other $state error...)
            $state.defaultErrorHandler(function (error) {
                console.log(error);
            });
        }]);

export default authModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/auth/index.js